import {
  REVEAL_WORDS_ACTION_TYPES,
  ACTIVITY_ACTION_TYPES,
  GRAPHIC_ORGANIZER_ACTION_TYPES,
  READING_ACTION_TYPES,
} from '../actions/action_types';

const initialRevealState = {
  revealId: null,
  position: null,
};

export const initialState = {
  all: {},
  currentWord: {
    revealId: null,
    position: null,
  },
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case REVEAL_WORDS_ACTION_TYPES.SET_REVEAL_WORDS: {
      const result = {};
      payload.forEach((word) => {
        result[word.id] = word;
      });
      return { ...state, all: result };
    }
    case REVEAL_WORDS_ACTION_TYPES.SET_REVEAL_WORD: {
      const { revealId, position } = payload;
      return { ...state, currentWord: { revealId, position } };
    }
    case REVEAL_WORDS_ACTION_TYPES.CLEAR_REVEAL_WORD:
    case ACTIVITY_ACTION_TYPES.SET_CURRENT_ACTIVITY:
    case GRAPHIC_ORGANIZER_ACTION_TYPES.OPEN: {
      return { ...state, currentWord: initialRevealState };
    }

    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initialState;

    default: {
      return state;
    }
  }
};
